import React from 'react';
interface Props { onChange: (values: Record<string, string>) => void; defaults?: Record<string, string>; }
export const FiltersBar: React.FC<Props> = ({ onChange, defaults }) => {
  const [values, setValues] = React.useState<Record<string, string>>(defaults ?? {});
  const handle = (key: string, value: string) => { const next = { ...values, [key]: value }; setValues(next); onChange(next); };
  return (
    <div className="flex flex-wrap gap-2 items-end text-sm">
      {['q','category','location','from','to'].map((k) => (
        <div key={k}><label className="block capitalize">{k === 'q' ? 'Buscar' : k}</label><input type={k === 'from' || k === 'to' ? 'date' : 'text'} className="input" defaultValue={values[k]} onChange={(e) => handle(k, e.target.value)} /></div>
      ))}
    </div>
  );
};
